<script setup>
import { useI18n } from 'vue-i18n';
import LaisModal from 'dashboard/components-next/LaisModal.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';
import confirmationImage from 'dashboard/assets/real-estate/sales-pending-charge/concluir-processo-2.png';

defineProps({
  address: { type: String, default: '' },
  show: { type: Boolean, default: false },
});
const emit = defineEmits(['close', 'confirm']);
const { t } = useI18n();
</script>

<template>
  <LaisModal
    :show="show"
    max-width-class="max-w-[1040px]"
    header-class="absolute right-2 top-2 z-10 !border-0 !p-0"
    @close="emit('close')"
  >
    <template #header>
      <span class="sr-only">
        {{ t('SALES.PENDING_CHARGE.CONFIRMATION.TITLE') }}
      </span>
    </template>
    <section
      data-testid="sales-pending-charge-confirmation"
      class="grid overflow-hidden rounded-lais-lg md:grid-cols-[minmax(0,482px)_minmax(0,1fr)]"
    >
      <div class="flex items-center justify-center bg-lais-bg-soft">
        <img
          :src="confirmationImage"
          :alt="t('SALES.PENDING_CHARGE.CONFIRMATION.ALT')"
          class="h-auto max-h-[533px] w-full max-w-[482px] object-contain"
        />
      </div>
      <div
        class="flex min-w-0 flex-col justify-between gap-8 p-5 sm:p-8 md:min-h-[533px] md:pb-[50px] md:pl-[54px] md:pr-[42px] md:pt-[50px]"
      >
        <div>
          <h2
            class="max-w-[380px] font-redHatDisplay text-2xl font-bold leading-tight text-lais-text md:text-[32px] md:leading-9"
          >
            {{ t('SALES.PENDING_CHARGE.CONFIRMATION.TITLE') }}
          </h2>
          <p
            class="mt-6 max-w-[380px] text-base leading-6 text-lais-text-body md:text-xl md:leading-6"
          >
            {{
              t('SALES.PENDING_CHARGE.CONFIRMATION.DESCRIPTION', {
                address: address ? `(${address})` : '',
              })
            }}
          </p>
        </div>
        <div class="flex justify-end">
          <LaisPrimaryButton
            data-testid="sales-pending-charge-confirmation-action"
            size="lg"
            icon="i-lucide-check"
            @click="emit('confirm')"
          >
            {{ t('SALES.PENDING_CHARGE.CONFIRMATION.ACTION') }}
          </LaisPrimaryButton>
        </div>
      </div>
    </section>
  </LaisModal>
</template>
